export default __webpack_public_path__ + "static/media/HIW2.4fa93081.svg";